import React from 'react';
import { ActionButton, ActionButtonModel } from '@/store/videoFeatures';
import { ButtonContentCard } from '../shared/ButtonContentCard';
import { ButtonTimingCard } from '../shared/ButtonTimingCard';
import { ButtonStyleCard } from '../shared/ButtonStyleCard';
import { PositionCard } from '../shared/PositionCard';
import { ButtonPreviewCard } from '../shared/ButtonPreviewCard';

interface OverVideoTabProps {
  actionButton: Partial<ActionButton>;
  updateActionButton: (key: string, value: any) => void;
  updateTemplate: (key: string, value: any) => void;
  onSelectModel: (model: ActionButtonModel) => void;
}

export const OverVideoTab: React.FC<OverVideoTabProps> = ({
  actionButton,
  updateActionButton,
  updateTemplate,
  onSelectModel,
}) => {
  const updateStyleProperty = (property: string, value: any) => {
    const currentStyle = actionButton.style || {};
    updateActionButton('style', {
      ...currentStyle,
      [property]: value,
    });
  };

  const updateTimingProperty = (property: string | Record<string, any>, value?: any) => {
    const currentTiming = actionButton.timing || {};
    const updates = typeof property === 'object' ? property : { [property]: value };
    updateActionButton('timing', { ...currentTiming, ...updates });
  };

  return (
    <div className="space-y-5">
      <PositionCard
        selectedPosition={actionButton.position}
        onPositionChange={(position) => updateActionButton('position', position)}
        offsetX={actionButton.horizontalOffset ?? 0}
        offsetY={actionButton.verticalOffset ?? 0}
        onOffsetXChange={(val) => updateActionButton('horizontalOffset', val)}
        onOffsetYChange={(val) => updateActionButton('verticalOffset', val)}
      />

      {/*
        Sobre o vídeo o botão é um elemento único, posicionado em cima do player.
        O bloco de oferta (headline, preço, barra de progresso) só existe abaixo
        do vídeo — daí `showTemplates={false}` nos dois cards.
      */}
      <ButtonContentCard
        actionButton={actionButton}
        updateActionButton={updateActionButton}
        updateTemplate={updateTemplate}
        onSelectModel={onSelectModel}
        showTemplates={false}
      />

      <ButtonTimingCard
        actionButton={actionButton}
        updateTimingProperty={updateTimingProperty}
      />

      <ButtonStyleCard
        actionButton={actionButton}
        updateStyleProperty={updateStyleProperty}
        updateTemplate={updateTemplate}
        showTemplates={false}
      />

      <ButtonPreviewCard actionButton={actionButton} variant="over" />
    </div>
  );
};
